<template>
    <TargetSegmentForm v-if="activeTSUuid !== null"></TargetSegmentForm>
</template>

<script>
import TargetSegmentForm from "./TargetSegmentForm.vue";
import { mapState } from "vuex";

export default {
    name: "EditTargetSegment",
    data() {
        return {
            form: {
                targetSegmentTitle: "",
                targetSegmentDescription: "",
                selectedGender: [],
                genderOptions: [
                    { text: "Female", value: "female" },
                    { text: "Male", value: "male" }
                ],
                selectedAgeGroup: [],
                ageGroupOptions: [
                    { text: "18 - 24 years", value: "18-24" },
                    { text: "25 - 34 years", value: "25-34" },
                    { text: "35 - 44 years", value: "35-44" },
                    { text: "45 years old and above", value: "45" }
                ],
                selectedBirthMonth: [],
                birthMonthOptions: [
                    { text: "January", value: 1 },
                    { text: "February", value: 2 },
                    { text: "March", value: 3 },
                    { text: "April", value: 4 },
                    { text: "May", value: 5 },
                    { text: "June", value: 6 },
                    { text: "July", value: 7 },
                    { text: "August", value: 8 },
                    { text: "September", value: 9 },
                    { text: "October", value: 10 },
                    { text: "November", value: 11 },
                    { text: "December", value: 12 }
                ],
                selectedTopCustomers: null,
                topCustomersOptions: [
                    { text: "All", value: null },
                    { text: "100", value: 100 },
                    { text: "200", value: 200 }
                ],
                allowProspects: false,
                allowNewMembers: false,
                allowNoPreviousMonthTransaction: false,
                selectedBranches: "all",
                branchesOptions: [
                    { text: "All Branches", value: "all" },
                    { text: "Pasig", value: "pasig" }
                ],
                allBranches: true,
                barangayList: [
                    {
                        id: 1,
                        name: "Bagong Ilog",
                        unit: "Pasig"
                    },
                    {
                        id: 2,
                        name: "Bagong Katipunan",
                        unit: "Pasig"
                    },
                    {
                        id: 3,
                        name: "Bambang",
                        unit: "Pasig"
                    },
                    {
                        id: 4,
                        name: "Dioquino Zobel",
                        unit: "Quezon City"
                    },
                    {
                        id: 5,
                        name: "Duyan-duyan",
                        unit: "Quezon City"
                    },
                    {
                        id: 6,
                        name: "E. Rodriguez",
                        unit: "Quezon City"
                    },
                    {
                        id: 7,
                        name: "Bagumbayan",
                        unit: "Taguig"
                    },
                    {
                        id: 8,
                        name: "Bambang",
                        unit: "Taguig"
                    },
                    {
                        id: 9,
                        name: "Calzada-Tipas",
                        unit: "Taguig"
                    }
                ],
                barangays: null
            }
        };
    },
    components: {
        TargetSegmentForm
    },
    computed: {
        ...mapState("customerTargetSegment", ["activeTSUuid", "targetSegment"])
    },
    created() {
        this.validatePage();
    },
    methods: {
        async validatePage() {
            if (this.activeTSUuid === null) {
                this.$router.push("/customers/target-segment");
            } else {
                this.$store.commit("customerTargetSegment/action", "edit");
                this.initForm();
            }
        },
        initForm() {
            let _this = this;
            this.$store
                .dispatch("customerTargetSegment/viewTargetSegment")
                .then(response => {
                    _this.form.brandVisibility = response.visibility;
                    _this.form.targetSegmentTitle = response.name;
                    _this.form.targetSegmentDescription = response.description;
                    let filters = JSON.parse(response.filters);

                    _this.form.selectedGender = filters.gender
                        ? filters.gender
                        : [];
                    _this.form.selectedAgeGroup = filters.age_group
                        ? filters.age_group
                        : [];
                    _this.form.selectedBirthMonth = filters.birth_month
                        ? filters.birth_month
                        : [];
                    //_this.form.selectedBranches = filters.branches ? filters.branches : [];
                    _this.form.selectedTopCustomers = filters.top_customer
                        ? filters.top_customer
                        : null;
                    _this.form.allowNewMembers = filters.new_member
                        ? filters.new_member
                        : false;
                    _this.form.allowProspects = filters.prospect
                        ? filters.prospect
                        : false;
                    _this.form.allowNoPreviousMonthTransaction = filters.no_previous_month_transaction
                        ? filters.no_previous_month_transaction
                        : false;
                });
            this.$store.dispatch(
                "customerTargetSegment/initializedForm",
                this.form
            );
        },
        async save(payload) {
            await this.$store.dispatch(
                "customerTargetSegment/updateTargetSegment",
                payload
            );
            this.resetForm();
        },
        resetForm() {
            return false;
        }
    }
};
</script>

<style scoped>
</style>
